if (!customElements.get("size-guide-fit")) {
  class SizeGuideFit extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        toggle: '.size-guide__toggle',
        btnCm: '.size-guide__btn-cm',
        btnFeet: '.size-guide__btn-feet',
        list: '.size-guide__list',
        sizeGuide: '[data-size-guide]',
        rowNodes: 'tbody tr',
        svg: '#geo-diagram',
        diagramGroups: '.diagram-group'
      };
    }

    connectedCallback() {
      this.domNodes = queryDomNodes( this.selectors, this );
      this.sizeData = JSON.parse( this.domNodes.sizeGuide.textContent )
      this.currentUnit = this.domNodes.defaultUnit;
      this.init();
    }

    init() {
      this.renderSizeBars();
      this.setupSwitchUnit();
      this.setupMouseListener();
    }

    setupSwitchUnit() {
      this.querySelectorAll('.size-guide__btn').forEach(button => {
        button.addEventListener('click', () => {
          this.currentUnit = button.classList.contains('size-guide__btn-cm') ? 'cm' : 'feet';
          this.querySelectorAll('.size-guide__btn').forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
          this.renderSizeBars();
          this.setAttribute('data-default-unit', this.currentUnit)
        });
      });
    }

    setupMouseListener() {
      const rowNodes = this.querySelectorAll(this.selectors.rowNodes);
      const svg = this.querySelector(this.selectors.svg);
      const svgDiagramNodes = svg.querySelectorAll(this.selectors.diagramGroups);

      rowNodes.forEach(row => {
        row.addEventListener("mouseenter", e => {
          const letterSrc = e.target.querySelector("[data-diagram-letter]");
          const letterValue = letterSrc.getAttribute("data-diagram-letter");
          this.activateOnEnter(letterValue, svg.querySelector(`#${letterValue}`));
        });

        row.addEventListener("mouseleave", e => {
          const letterSrc = e.target.querySelector("[data-diagram-letter]");
          const letterValue = letterSrc.getAttribute("data-diagram-letter");
          this.deactivateOnLeave(letterValue, svg.querySelector(`#${letterValue}`));
        });
      });

      svgDiagramNodes.forEach(node => {
        node.addEventListener("mouseenter", e => {
          const letterID = e.target.getAttribute("id");
          const target = this.querySelector(`[data-diagram-letter="${letterID}"]`);
          target&&this.activateOnEnter(letterID, target.parentElement);
        });

        node.addEventListener("mouseleave", e => {
          const letterID = e.target.getAttribute("id");
          const target = this.querySelector(`[data-diagram-letter="${letterID}"]`);
          target&&this.deactivateOnLeave(letterID, target.parentElement);
        });
      });
    }

    renderSizeBars() {
      const min = parseInt(this.domNodes.list.dataset.minSize);
      const max = parseInt(this.domNodes.list.dataset.maxSize);
      const min_range = parseInt(this.domNodes.list.dataset.minSizeRange);
      const max_range = parseInt(this.domNodes.list.dataset.maxSizeRange);

      this.sizeData.forEach(data => {
        const startValueCm = data.min_height;
        const endValueCm = data.max_height;
        const startValueRange = data.min_range;
        const endValueRange = data.max_range;
        let height_space = this.querySelector(`[data-height-space="${data.title}"]`);
        let height_bar = this.querySelector(`[data-height-bar="${data.title}"]`);
        let range_space = this.querySelector(`[data-range-space="${data.title}"]`);
        let range_bar = this.querySelector(`[data-range-bar="${data.title}"]`);

        const barStartPercent = ((startValueCm - min) / (max - min)) * 100;
        const barWidthPercent = ((endValueCm - startValueCm) / (max - min)) * 100;
        const rangeBarStartPercent = ((startValueRange - min_range) / (max_range - min_range)) * 100;
        const rangeBarWidthPercent = ((endValueRange - startValueRange) / (max_range - min_range)) * 100;

        height_space&&(height_space.style.width = `${barStartPercent}%`);
        height_bar&&(height_bar.style.width = `${barWidthPercent}%`);
        range_space&&(range_space.style.width = `${rangeBarStartPercent}%`);
        range_bar&&(range_bar.style.width = `${rangeBarWidthPercent}%`);
      });
    }

    activateOnEnter(value, target) {
      value & target.classList.add('hovered')
    }

    deactivateOnLeave(value, target) {
      value & target.classList.remove('hovered')
    }
  }

  customElements.define('size-guide-fit', SizeGuideFit);
}